@let _productList = llmTrial.productList();

<div class="ada-full-height ada-position-relative ada-container ada-flex-column ada-col-1">
	<div
		ada-background-color="background-2"
		class="ada-container ada-colspan-1 ada-col-1 ada-vspacing-medium ada-flex-column ada-flex-grow ada-overflowY-auto"
		[style.padding]="ui.Spacing.SPACING_LARGE"
	>
		<div class="ada-colspan-1">
			<span
				ada-color="primary"
				ada-font-weight="bold"
				ada-type="large"
				[style.line-height]="ui.Spacing.SPACING_XLARGE"
			>
				Meet {{ aida.displayName() }}: Your intelligent, AI-powered endpoint management assistant.
			</span>
		</div>
		<div class="ada-colspan-1">
			<span ada-color="foreground">
				{{ aida.displayName() }} works with select products as an add-on. Start a free trial to add {{ aida.displayName() }} to your existing
				endpoint management suite, or check out other {{ branding.oem() }} products.
			</span>
		</div>

		@if (!llmTrial.hasPermissions()) {
			<ada-alert
				data-testid="ada-llm-free-trial-permissions-alert"
				[isClosable]="true"
				[title]="'Please contact your administrator to start a free trial'"
			/>
		}

		@for (_product of _productList; track $index) {
			<ada-card
				[collapseEnabled]="true"
				[fullscreenEnabled]="false"
			>
				<span
					class="product-name ada-colspan-1 ada-color-foreground"
					data-container-selector="ada-card-header"
				>
					{{ _product.skuName }}
				</span>

				<div
					ada-color="foreground"
					class="ada-container ada-colspan-1 ada-col-1"
					data-container-selector="ada-card-body"
				>
					<div class="ada-colspan-2">
						{{ _product.skuDescription }}
					</div>
					<div class="ada-container ada-col-1 ada-colspan-3"></div>
				</div>
				<div
					class="ada-container ada-flex-align-center ada-flex-justify-between"
					data-container-selector="ada-card-footer"
				>
					<span
						ada-font-weight="bold"
						class="ada-colspan-1"
						[ngClass]="_product | adaAiProductTrialColor"
					>
						{{ _product | adaAiProductTrialText }}
					</span>

					@if (!(_product | adaAiProductTrialDisabled)) {
						<div class="ada-container ada-flex-align-center">
							<ada-label
								content="Start Trial"
								[associatedWith]="TrialToggle"
								[style.margin-right]="ui.Spacing.SPACING_MEDIUM"
							/>
							<ada-toggle-switch
								#TrialToggle
								data-testid="ada-llm-free-trial-toggle"
								[attr.data-sku-name]="_product.skuName"
								[isToggled]="_product.isActive"
								(isToggledChange)="toggleSku(_product, $event)"
							/>
						</div>
					} @else if (llmTrial.hasPermissions()) {
						<a
							class="ada-btn ada-btn-sm"
							routerLink="/licensing"
						>
							Manage
						</a>
					}
				</div>
			</ada-card>
		}
	</div>
	<div
		ada-background-color="background"
		class="llm-free-trial-footer ada-container ada-border-top ada-col-1 ada-flex-justify-between ada-flex-align-center"
	>
		@let _selectedSkus = selectedSkus();

		<button
			class="ada-btn ada-btn-solid ada-full-width ada-btn-no-margin"
			data-testid="llm-free-trial-button"
			tooltip="Confirm"
			[class.is-disabled]="isDisabled || !_selectedSkus.length"
			(click)="onSubmitButtonClicked()"
		>
			Confirm
		</button>
	</div>
</div>
